var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBnbChain = function SvgBnbChain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.053 3.739 10.5 0l6.447 3.739-2.37 1.38L10.5 2.763 6.423 5.12l-2.37-1.381Zm12.894 4.715-2.37-1.381L10.5 9.43 6.423 7.073l-2.37 1.38v2.763l4.077 2.358v4.715l2.37 1.38 2.37-1.38v-4.715l4.077-2.358V8.454Zm0 7.477V13.17l-2.37 1.38v2.763l2.37-1.38Zm1.683.976-4.077 2.358v2.762L21 18.29V10.81l-2.37 1.381v4.715Zm-2.37-10.81 2.37 1.38v2.763L21 8.859V6.096l-2.37-1.381-2.37 1.381ZM8.13 20.264v2.762l2.37 1.382 2.37-1.382v-2.762l-2.37 1.381-2.37-1.38Zm-4.077-4.334 2.37 1.381V14.55l-2.37-1.381v2.762ZM8.13 6.096l2.37 1.381 2.37-1.38-2.37-1.382-2.37 1.381ZM2.37 7.477l2.37-1.38-2.37-1.382L0 6.096V8.86l2.37 1.38V7.478Zm0 4.715L0 10.812v7.477l6.447 3.738v-2.762L2.37 16.907v-4.715Z",
    fill: "#000"
  })));
};

export default SvgBnbChain;